import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListShippingsActions } from "store/ducks/shippings";

import { ShippingType } from "interfaces/shipping-type";

export function* listShippingsRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(api.get, `/shipping-types?${queryString}`);
    const comboOptions = data.map((shipping: ShippingType) => ({
      value: shipping.id,
      label: shipping.name
    }));

    yield put(ListShippingsActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListShippingsActions.failure(errorMessage));
  }
}
